/**
 * A component that restricts access to admin-only routes.
 * Redirects non-admin users to the home page.
 * Shows nothing during authentication loading state.
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render if user is admin
 * @returns {React.ReactElement|null} The protected children or redirect component
 */

import React from 'react';
import { useAuth } from './context';
import { Navigate } from 'react-router-dom';

const RequireAdmin: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return null; // or loading spinner
  if (!user || !user.isAdmin) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};

export default RequireAdmin;
